import { render, staticRenderFns } from "./CommitteeDetails.vue?vue&type=template&id=69690818&"
import script from "./CommitteeDetails.vue?vue&type=script&lang=js&"
export * from "./CommitteeDetails.vue?vue&type=script&lang=js&"
import style0 from "./CommitteeDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports